// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file auth/generate_auth_token.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { Level, PharmacyAccess, Role } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.GenerateAuthTokenRequest
 */
export class GenerateAuthTokenRequest extends Message<GenerateAuthTokenRequest> {
  /**
   * Username of the user requesting the token
   *
   * @generated from field: string username = 1;
   */
  username = "";

  /**
   * Password of the user requesting the token
   *
   * @generated from field: string password = 2;
   */
  password = "";

  /**
   * Access level for the token
   *
   * @generated from field: com.neulink.pharmacy.Level level = 3;
   */
  level = Level.UNSPECIFIED;

  /**
   * Unique identifier for the pharmacy, branch, or stock point
   *
   * @generated from field: string id = 4;
   */
  id = "";

  constructor(data?: PartialMessage<GenerateAuthTokenRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.GenerateAuthTokenRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "level", kind: "enum", T: proto3.getEnumType(Level) },
    { no: 4, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GenerateAuthTokenRequest {
    return new GenerateAuthTokenRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GenerateAuthTokenRequest {
    return new GenerateAuthTokenRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GenerateAuthTokenRequest {
    return new GenerateAuthTokenRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GenerateAuthTokenRequest | PlainMessage<GenerateAuthTokenRequest> | undefined, b: GenerateAuthTokenRequest | PlainMessage<GenerateAuthTokenRequest> | undefined): boolean {
    return proto3.util.equals(GenerateAuthTokenRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.GenerateAuthTokenResponse
 */
export class GenerateAuthTokenResponse extends Message<GenerateAuthTokenResponse> {
  /**
   * Generated authentication token
   *
   * @generated from field: string token = 1;
   */
  token = "";

  /**
   * Name of the pharmacy, branch, or stock point
   *
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * Unique identifier for the pharmacy, branch, or stock point
   *
   * @generated from field: string id = 3;
   */
  id = "";

  /**
   * List of roles associated with the access
   *
   * @generated from field: repeated com.neulink.pharmacy.Role roles = 4;
   */
  roles: Role[] = [];

  /**
   * Expiration time of the token in ISO 8601 format
   *
   * @generated from field: string expires_at = 5;
   */
  expiresAt = "";

  /**
   * Issuance time of the token in ISO 8601 format
   *
   * @generated from field: string issued_at = 6;
   */
  issuedAt = "";

  /**
   * Unique identifier for the user
   *
   * @generated from field: int32 user_id = 7;
   */
  userId = 0;

  /**
   * Username of the user
   *
   * @generated from field: string user_name = 8;
   */
  userName = "";

  /**
   * First name of the user
   *
   * @generated from field: string user_first_name = 9;
   */
  userFirstName = "";

  /**
   * Last name of the user
   *
   * @generated from field: string user_last_name = 10;
   */
  userLastName = "";

  /**
   * List of pharmacy access details for switching contexts
   *
   * @generated from field: repeated com.neulink.pharmacy.PharmacyAccess access = 11;
   */
  access: PharmacyAccess[] = [];

  /**
   * Refresh token for obtaining a new auth token
   *
   * @generated from field: string refresh_token = 12;
   */
  refreshToken = "";

  constructor(data?: PartialMessage<GenerateAuthTokenResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.GenerateAuthTokenResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "roles", kind: "enum", T: proto3.getEnumType(Role), repeated: true },
    { no: 5, name: "expires_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "issued_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "user_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "user_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "user_first_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "user_last_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "access", kind: "message", T: PharmacyAccess, repeated: true },
    { no: 12, name: "refresh_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GenerateAuthTokenResponse {
    return new GenerateAuthTokenResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GenerateAuthTokenResponse {
    return new GenerateAuthTokenResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GenerateAuthTokenResponse {
    return new GenerateAuthTokenResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GenerateAuthTokenResponse | PlainMessage<GenerateAuthTokenResponse> | undefined, b: GenerateAuthTokenResponse | PlainMessage<GenerateAuthTokenResponse> | undefined): boolean {
    return proto3.util.equals(GenerateAuthTokenResponse, a, b);
  }
}

